import { render, staticRenderFns } from "./compimport.vue?vue&type=template&id=6ecd5e88"
import script from "./compimport.vue?vue&type=script&lang=js"
export * from "./compimport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports